import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { colors, buildTheme as buildBaseTheme } from '@spa/shared/theme';
var buildTheme = function buildTheme() {
  var colors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, buildBaseTheme(colors)), {}, {
    separator: {
      color: colors.paleGray
    },
    headerTitle: {
      title: {
        color: colors.blueDianne
      },
      tags: {
        color: colors.blueDianne,
        separatorColor: colors.cornFlowerBlue
      },
      location: {
        color: colors.blueDianne
      },
      actions: {
        color: colors.cornFlowerBlue
      }
    },
    shareModal: {
      subtitle: colors.cornFlowerBlue
    },
    galleryButtons: {
      mapIcon: {
        stroke: colors.cornFlowerBlue
      }
    },
    photosModal: {
      title: {
        color: colors.blueDianne
      },
      reference: {
        color: colors.cornFlowerBlue
      },
      shareAndWishlist: {
        color: colors.lightest
      },
      carouselSection: {
        background: colors.blueDianne,
        textColor: colors.lightest,
        closeIconColor: colors.lightest,
        button: {
          hover: colors.lightDianne
        },
        navigationControls: {
          background: colors.lightest,
          svgColor: colors.cornFlowerBlue
        },
        counter: {
          background: colors.japaneseIndigo,
          textColor: colors.lightest
        },
        chips: {
          borderColor: colors.shadyGray,
          textColor: colors.blueDianne
        }
      },
      stickyHeader: {
        background: colors.pearlWhite
      },
      actionSvgStroke: colors.cornFlowerBlue
    },
    overview: {
      yourSpace: {
        title: {
          color: colors.blueDianne
        },
        description: {
          color: colors.blueDianne
        },
        features: {
          color: colors.blueDianne
        },
        spaceInfo: {
          title: {
            color: colors.blueDianne
          },
          description: {
            color: colors.cornFlowerBlue
          }
        }
      },
      aboutThisPlace: {
        text: {
          color: colors.blueDianne
        },
        roommatesIcon: {
          fill: colors.lightest
        }
      },
      energyCertification: {
        text: {
          color: colors.blueDianne
        }
      },
      sharedSpacesAndAmenities: {
        text: {
          color: colors.blueDianne
        }
      }
    },
    availabilitySection: {
      description: {
        color: colors.blueDianne
      }
    },
    pricingBox: {
      background: colors.lightest,
      shadow: 'rgba(34, 66, 81, 0.2)',
      border: colors.paleGray,
      dates: {
        date: colors.blueDianne,
        label: colors.cornFlowerBlue,
        border: colors.blueDianne
      },
      price: {
        mainColor: colors.blueDianne,
        secondaryColor: colors.cornFlowerBlue,
        tertiaryColor: colors.mountainMeadow
      },
      paymentInfo: {
        title: colors.cornFlowerBlue
      },
      notification: {
        boxShadow: "0px 6px 12px 0px ".concat(colors.mercury)
      }
    },
    landlordSection: {
      textColor: colors.blueDianne,
      pill: {
        textColor: colors.lightest
      },
      card: {
        billsIncludedColor: colors.shadyGray
      }
    },
    sections: {
      border: {
        color: colors.paleGray
      },
      separator: {
        color: colors.wildSand
      }
    },
    rentalConditionsSection: {
      text: {
        color: colors.blueDianne
      }
    },
    contract: {
      title: {
        color: colors.blueDianne
      },
      description: {
        color: colors.blueDianne
      }
    },
    accordion: {
      background: colors.wildSand,
      urlText: colors.uniBlue,
      title: colors.blueDianne,
      text: colors.cornFlowerBlue,
      chevron: colors.cornFlowerBlue,
      backgroundColor: colors.yellow100,
      titleColor: colors.blueDianne,
      textColor: colors.cornFlowerBlue,
      svgColor: colors.blueDianne
    },
    referAFriend: {
      color: colors.uniBlue
    },
    morePlacesLikeThisSection: {
      textColor: colors.blueDianne
    },
    servicesExpensesSection: {
      text: {
        color: colors.blueDianne
      },
      billsGridItem: {
        background: colors.lightest,
        colors: {
          billIncluded: colors.mountainMeadow
        }
      },
      statusBanner: {
        textColor: colors.cornFlowerBlue
      }
    },
    whereYoullBeLivingSection: {
      textColor: colors.blueDianne,
      helperTextColor: colors.cornFlowerBlue
    },
    breadcrumbs: {
      text: {
        color: colors.uniBlue
      },
      lastItem: {
        color: colors.shadyGray
      }
    },
    fomo: {
      views: {
        background: colors.lightest,
        text: colors.redStone
      },
      hours: {
        background: colors.redStone,
        text: colors.lightest
      }
    },
    tooltip: {
      iconColor: colors.blueDianne
    },
    whyRentWithUniplaces: {
      borderColor: colors.paleGray,
      titleColor: colors.blueDianne,
      textColor: colors.blueDianne
    }
  });
};
export var theme = buildTheme(colors);